import React, { useEffect,useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import meDashboard from "components/assets/Me Dash.png"
import Challenges from "components/assets/Challenges.png"
import Leaderboard from "components/assets/Team Leaderboard.png"
import { FaRunning, FaBullseye, FaUsers, FaUserCircle } from 'react-icons/fa';
import { FaGamepad, FaGift, FaUsersCog, FaChartLine } from 'react-icons/fa';
import { LuNetwork } from 'react-icons/lu';
import COFITLOGO from "components/assets/COFIT_LOGO-removebg-preview.png"

const ExplorePage = () => {
  const navigate = useNavigate();
  const [showInstallHint, setShowInstallHint] = useState(false);
const isDesktop = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) === false;


useEffect(() => {
  const hasSeen = localStorage.getItem("seen_download_hint");
  if (isDesktop && !hasSeen) {
    setShowInstallHint(true);
    localStorage.setItem("seen_download_hint", "true");
  }
}, []);

useEffect(() => {
    const handleBack = () => {
      localStorage.clear();
      navigate("/login", { replace: true });
    };

    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", handleBack);

    return () => {
      window.removeEventListener("popstate", handleBack);
    };
  }, [navigate]);
  return (
    <PageContainer>
      <TopNav>
        <Logo>
        <img src={COFITLOGO} alt="Cofit Logo" />
        </Logo>
       <LoginButton
  onClick={() => {
    localStorage.clear();
    navigate('/login');
  }}
>
  Login
</LoginButton>

      </TopNav>
{showInstallHint && (
  <StickyBanner>
    💡 Info: Want to install the Cofit app? Open this site on your mobile and Download the App.
    <CloseBtn onClick={() => setShowInstallHint(false)}>×</CloseBtn>
  </StickyBanner>
)}

      <Content>
        <Header>
          <Title>Explore Cofit</Title>
          <Subtitle>
            Your all-in-one corporate wellness companion. Track your Fitness Metrics and goal progress with personalized dashboards
            and vibrant analytics and Organization level Fitness details.
          </Subtitle>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6, duration: 1 }}
          >
          </motion.p>
        </Header>
        
            <MockupSection>
            <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ amount: 0.3 }}
            >
            <MockupCardRow reverse={false}>
                <MockupText>
                <h3>Your Personalized Dashboard</h3>
                <p>Stay on top of your fitness journey with real-time insights into your daily goals and progress trends.</p>
                </MockupText>
                <MockupImage>
                <img src={meDashboard} alt="Me Dashboard preview" />
                </MockupImage>
            </MockupCardRow>
            </motion.div>

             <motion.div
             initial={{ opacity: 0, y: 50 }}
             whileInView={{ opacity: 1, y: 0 }}
             transition={{ duration: 0.6 }}
             viewport={{ amount: 0.3 }}
              >
            <MockupCardRow reverse={true}>
               
                <MockupText>
                <h3>Engaging Challenges That Drive Results</h3>
                <p>Join challenges solo or with your team and compete in fun, rewarding ways to build lasting habits.</p>
                </MockupText>
                 <MockupImage>
                <img src={Challenges} alt="Challenges preview" />
                </MockupImage>
            </MockupCardRow>
            </motion.div>
                    <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ amount: 0.3 }}
                      >
             <MockupCardRow reverse={false}>
                
                <MockupText>
                <h3>Celebrate Success on the Leaderboard</h3>
                <p>Track top performers and stay motivated by seeing how others in your team are doing.</p>
                </MockupText>
                <MockupImage>
                <img src={Leaderboard} alt="Leaderboard preview" />
                </MockupImage>
            </MockupCardRow>
            </motion.div>
            </MockupSection>


        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <SectionTitle>Discover What Cofit Brings to Your Wellness Journey</SectionTitle>
          <FeatureGrid>
          <FeatureCard>
        <FaRunning size={40} color="#007d8c" />
        <h3>Fitness Metrics Tracking</h3>
        <p>Visualize daily activity with beautiful charts and stats.</p>
        </FeatureCard>

        <FeatureCard>
        <FaBullseye size={40} color="#007d8c" />
        <h3>Goal Completion</h3>
        <p>Get rewarded for smashing your fitness goals.</p>
        </FeatureCard>

        <FeatureCard>
        <FaUserCircle size={40} color="#007d8c" />
        <h3>Personalized Me Dashboard</h3>
        <p>Track your own trends and progress in one glance.</p>
       </FeatureCard>

        <FeatureCard>
        <FaUsers size={40} color="#007d8c" />
        <h3>Team Dashboard</h3>
        <p>See how your team stacks up and grow together.</p>
        </FeatureCard>

       </FeatureGrid>
       </motion.div>
       <motion.div
       initial={{ opacity: 0, y: 50 }}
       whileInView={{ opacity: 1, y: 0 }}
       transition={{ duration: 0.6 }}
       viewport={{ once: true }}
       >
       <SectionTitle>Why Cofit is the Ultimate Fitness Companion for Corporate</SectionTitle>
       <FeatureGrid>
       <FeatureCard>
        <FaGamepad size={40} color="#007d8c" />
        <h3>Gamified Experience</h3>
        <p>Earn badges and points for completing healthy actions.</p>
        </FeatureCard>

        <FeatureCard>
        <FaGift size={40} color="#007d8c" />
        <h3>Join & Win</h3>
        <p>Participate in challenges and win exciting rewards.</p>
        </FeatureCard>

        <FeatureCard>
        <LuNetwork size={40} color="#007d8c" />
        <h3>Peer Motivation</h3>
        <p>See your org structure and how your peers perform.</p>
        </FeatureCard>

        <FeatureCard>
        <FaChartLine size={40} color="#007d8c" />
        <h3>Progress Insights</h3>
        <p>Understand your growth through graphs and historical trends.</p>
        </FeatureCard>
          </FeatureGrid>
        </motion.div>

         {/* <SectionTitle>The Power of Cofit Mobile</SectionTitle>
<MobilePreviewSection>
  <MobileText>
    <h3>Automatic Sync with Google Fit</h3>
    <p>Your daily steps, distance, and calories are automatically tracked using Health Connect from your phone. No manual logging needed.</p>
    <h3>Real-time Challenge Updates</h3>
    <p>Whether it’s solo or team play, your progress updates instantly in the app.</p>
  </MobileText>
  <MobileImage>
    <img src="/mobile-preview.png" alt="Cofit Mobile App" />
  </MobileImage>
</MobilePreviewSection>*/}


        <SectionTitle>Ready to Begin?</SectionTitle>
        <Centered>
          <LoginButton onClick={() => navigate('/login')}>Join Cofit</LoginButton>
        </Centered> 
      </Content>
    </PageContainer>
  );
};

export default ExplorePage;

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background:rgba(93, 236, 231, 1);
  font-family: 'Segoe UI', sans-serif;
`;

const TopNav = styled.div`
  display: flex;
  position: sticky;
   top: 0;
  z-index: 1000;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
    height: 54px;
  background-color: #f8f9fa;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
   backdrop-filter: blur(6px);
`;

const Logo = styled.div`
  display: flex;
  align-items: center;

  img {
    height: 80px;
    transform: scale(1.4);  /* visually larger without breaking layout */
    transform-origin: left center;
  }
`;
const LoginButton = styled.button`
  padding: 10px 24px;
  background: rgba(93, 236, 231, 1);
  color: #004d4d;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(93, 236, 231, 0.4);
  transition: all 0.3s ease;

  &:hover {
    background: #4dd9d4;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
  }
`;


const Content = styled.div`
  flex: 1;
  padding: 2rem 3rem;
`;

const Header = styled.div`
  max-width: 800px;
`;

const Title = styled.h1`
  color: #007d8c;
  font-size: 36px;
  margin-bottom: 1rem;
`;

const Subtitle = styled.p`
  font-size: 18px;
  color: #444;
`;

const MockupSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
  margin: 4rem 0;
`;


const MockupCardRow = styled.div<{ reverse?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  align-items: center;
  justify-content: center;
  flex-direction: ${({ reverse }) => (reverse ? 'row-reverse' : 'row')};
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const MockupImage = styled.div`
  flex: 1;
  text-align: center;

  img {
    max-width: 100%;
     min-width: 280px;
     max-height: 480px;
     min-height:auto;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  }
`;

const MockupText = styled.div`
  flex: 1;
  max-width: 500px;

  h3 {
    font-size: 40px;
    color: #007d8c;
    margin-bottom: 0.5rem;
  }

  p {
    font-size: 18px;
    color: #555;
  }
`;

const SectionTitle = styled.h2`
  margin-top: 3rem;
  color: #007d8c;
  text-align: center;
  font-size: 28px;
  font-weight: 600;
`;

const FeatureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 2rem;
  margin-top: 1.5rem;
  justify-items: center;
`;

const FeatureCard = styled.div`
  background: white;
  padding: 2rem 1.5rem;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  text-align: center;
  transition: transform 0.3s ease;
  font-family: 'Poppins', sans-serif;

  svg {
    background: #e5f9f8;
    padding: 0.75rem;
    border-radius: 50%;
    color: #007d8c;
    font-size: 24px;
    margin-bottom: 1rem;
  }

  &:hover {
    transform: translateY(-4px);
  }

  h3 {
    color: #202020;
    font-size: 18px;
    margin-bottom: 0.5rem;
    font-weight: 600;
  }

  p {
    color: #666;
    font-size: 14px;
  }
`;
const Centered = styled.div`
  text-align: center;
  margin-top: 2rem;
`;
const StickyBanner = styled.div`
  background-color: #fff3cd;
  color: #856404;
  padding: 12px 20px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 0 0 6px 6px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
`;

const CloseBtn = styled.span`
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  margin-left: 20px;
`;

// const MobilePreviewSection = styled.div`
//   display: flex;
//   gap: 2rem;
//   margin-top: 3rem;
//   align-items: center;
//   flex-wrap: wrap;
// `;

// const MobileText = styled.div`
//   flex: 1;
//   h3 {
//     color: #007d8c;
//     margin-bottom: 0.5rem;
//   }
//   p {
//     color: #555;
//     margin-bottom: 1rem;
//   }
// `;

// const MobileImage = styled.div`
//   flex: 1;
//   text-align: center;
//   img {
//     max-width: 250px;
//     border-radius: 20px;
//     box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
//   }
// `;
